import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useData } from "@pure-ptr/react";
import { DeleteConfirmation } from "../../../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog";
import { ContractInfo } from "../../../../store/api/ai-api";
import { errorToastify } from "../../../../util/toast";
import { ToastMessage } from "../../../../common";

const ContractDocumentDelete = ({ rowData, getDocuments }) => {
    const [confirmDialogData, setConfirmDialogData] = useState({
        open: false,
        rowData: null,
    });
    const [documentDeletePayload, setDocumentDeletePayload] = useState(null);
    const ContractsApi = new ContractInfo();

    const {
        data,
        isPending,
        error,
    } = useData(async () => {
        if (!documentDeletePayload) return;
        setDocumentDeletePayload(null);
        const deletionResponse = await ContractsApi.deleteDocuments(
            documentDeletePayload
        );

         Promise.resolve(
             ContractsApi.refreshContractAfterDocumentDeletion(
                 confirmDialogData?.rowData?.contractId
             ).catch((err) => {
                 console.error("err:", err);
             })
         );

        getDocuments();
        return deletionResponse;
    }, [documentDeletePayload]);

    useEffect(() => {
        if (!error) return;
        errorToastify(
            <ToastMessage
                errorMessage={error?.payload?.error}
                innerException={error?.payload?.innerException}
                errorDetails={error?.payload?.errorDetails}
            />
        );
    }, [error]);

    return (
        <div>
            <IconButton
                color="primary"
                className="p-1"
                aria-label="Edit"
                onClick={() => setConfirmDialogData({ open: true, rowData })}
                size="large"
            >
                <Tooltip title="Delete">
                    <Delete />
                </Tooltip>
            </IconButton>

            <DeleteConfirmation
                DELETE_TEXT={`Are you sure you want to delete this document?`}
                defaultSelected={[]}
                handleDelete={(ids) => setDocumentDeletePayload(ids[0])}
                isDeleting={isPending != null}
                defaultDeleteState={confirmDialogData}
                handleClose={() =>
                    setConfirmDialogData({ open: false, rowData: null })
                }
            />
        </div>
    );
};

export default ContractDocumentDelete;
